import type { BackendModule, ReadCallback } from 'i18next'

type LanguageLoaders = Record<
  string,
  () => Promise<{
    // biome-ignore lint/suspicious/noExplicitAny: We don't know the shape of translations
    default: Record<string, any>
  }>
>

export const makeImportBackend = (loaders: LanguageLoaders): BackendModule => ({
  type: 'backend',
  init: () => {}, // The init function is called by i18next to pass options and services. We don't need any options for this backend.
  read(language: string, namespace: string, callback: ReadCallback) {
    if (language.includes('-')) language = language.split('-')[0]

    const promise = loaders[language]?.()

    if (!promise) {
      callback(new Error(`Language '${language}' not supported`), null)
      return
    }

    promise
      .then((module) => {
        const translations = module.default
        if (translations?.[namespace]) {
          callback(null, translations[namespace])
        } else {
          callback(
            new Error(
              `Translations not found for language '${language}' and namespace '${namespace}'`,
            ),
            null,
          )
        }
      })
      .catch((error) => {
        callback(error, null)
      })
  },
})
